import React, { useEffect, useState } from "react";
import LanguageDropdown from "./LanguageDropdown";
import useAuth from "../../../hooks/useAuth";
import UserNavOption from "./UserNavOption";
import TranslateComponent from "../TranslateComponent";

const NavBar = () => {
  const { getAuth } = useAuth();

  const [role, setRole] = useState("");
  useEffect(() => {
    setRole(getAuth()?.role);
  }, [getAuth]);
  return (
    <nav className="flex justify-between  items-center px-[1rem] sm:px-[1.875rem] text-white h-[4.5rem] bg-secondary-color">
      <div className="flex flex-row items-center gap-[2rem]">
        <h2 className="font-poppins text-[1.5rem] leading-normal hidden md:block font-semibold">Kalkulátor {role !== "cal_user" && "admin"} felület</h2>
      </div>
      <div className="flex flex-row items-center gap-[1.875rem]">
        {/* <LanguageDropdown /> */}
        <div className="bg-teal-700 px-3 !text-white rounded">
          <TranslateComponent />
        </div>
        <UserNavOption />
      </div>
    </nav>
  );
};

export default NavBar;
